module.exports = __webpack_public_path__ + "static/media/logo.4db79a76.png";